import React from "react";
import { HOME_THEME as T } from "../../lib/homeTheme";

interface StaffDividerProps {
  className?: string;
}

/** Pentagrama abstracto — 5 líneas ultra-sutiles */
export const StaffDivider: React.FC<StaffDividerProps> = ({ className = "" }) => {
  return (
    <div
      className={`flex w-full flex-col gap-[3px] py-2 ${className}`}
      role="presentation"
      aria-hidden
    >
      {Array.from({ length: 5 }).map((_, i) => (
        <div
          key={i}
          className="h-px w-full"
          style={{ backgroundColor: T.staffLine, opacity: 0.05 }}
        />
      ))}
    </div>
  );
};
